'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var processQueryDocs = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(props, prevProps) {
    var db, setDocs, docs;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!prevProps || props.query !== prevProps.query || props.page.view !== prevProps.page.view)) {
              _context.next = 10;
              break;
            }

            db = props.db, setDocs = props.setDocs;

            props.setIsLoading(true);
            _context.next = 5;
            return db.queryDocs(props.query);

          case 5:
            docs = _context.sent;
            _context.next = 8;
            return new Promise(function (resolve) {
              return setDocs(docs, resolve);
            });

          case 8:
            props.setIsLoading(false);
            return _context.abrupt('return', docs);

          case 10:
            return _context.abrupt('return', null);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function processQueryDocs(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _omit = require('lodash/fp/omit');

var _omit2 = _interopRequireDefault(_omit);

var _merge = require('lodash/fp/merge');

var _merge2 = _interopRequireDefault(_merge);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _withStateByProps = require('coact-utils/withStateByProps');

var _withStateByProps2 = _interopRequireDefault(_withStateByProps);

var _bindHotKeys = require('coact-utils/bindHotKeys');

var _bindHotKeys2 = _interopRequireDefault(_bindHotKeys);

var _controlToolButton = require('./controlToolButton');

var _controlToolButton2 = _interopRequireDefault(_controlToolButton);

var _getSchemaKeys = require('../../utils/schema/getSchemaKeys');

var _getSchemaKeys2 = _interopRequireDefault(_getSchemaKeys);

var _DocList = require('./DocList');

var _DocList2 = _interopRequireDefault(_DocList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function getUi(_ref) {
  var uiSetting = _ref.uiSetting,
      schema = _ref.schema;

  if (uiSetting && uiSetting.editor) return uiSetting.list;
  var keys = (0, _getSchemaKeys2.default)(schema, true).filter(function (opt) {
    return !['_id', '@@createdAt', '@@updatedAt', '@@deletedAt'].includes(opt);
  });
  return {
    columns: keys.map(function (k) {
      return { key: k };
    })
  };
}

function updateQueryByFields(query, fields) {
  // if field is removed, omit it in new query
  return Object.keys(query).reduce(function (q, k) {
    if (fields.find(function (f) {
      return f === k;
    })) return q;
    return (0, _omit2.default)(k)(q);
  }, query);
}

exports.default = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  db: _propTypes.object.isRequired,
  uiSetting: _propTypes.object
}), (0, _injectProps2.default)({
  page: _propTypes.object.isRequired,
  schema: _propTypes.object.isRequired
}),

// test fixedQuery
(0, _withProps2.default)(function (_ref3) {
  var _ref3$uiSetting = _ref3.uiSetting;
  _ref3$uiSetting = _ref3$uiSetting === undefined ? {} : _ref3$uiSetting;
  var _ref3$uiSetting$list = _ref3$uiSetting.list;
  _ref3$uiSetting$list = _ref3$uiSetting$list === undefined ? {} : _ref3$uiSetting$list;
  var _ref3$uiSetting$list$ = _ref3$uiSetting$list.query,
      query = _ref3$uiSetting$list$ === undefined ? {} : _ref3$uiSetting$list$;
  return {
    fixedQuery: query.fixedQuery || {}
  };
}),

// FieldSelect state
(0, _withState2.default)('fields', 'setFields', []),

// QueryEditor state, depends fields state
(0, _withStateByProps2.default)('query', 'setQuery', function (nextProps, props) {
  var fixedQuery = nextProps.fixedQuery;


  if (!props) return fixedQuery; // clear query
  if (props.fields !== nextProps.fields) {
    // use updater to update state
    return function (query) {
      return (0, _merge2.default)(updateQueryByFields(query, nextProps.fields), fixedQuery);
    };
  }
  return undefined; // Do not update state
}), (0, _withHandlers2.default)({
  setQuery: function setQuery(_ref4) {
    var _setQuery = _ref4.setQuery,
        fixedQuery = _ref4.fixedQuery;
    return function (updater) {
      return _setQuery(function (query) {
        return (0, _merge2.default)(updater(query), fixedQuery);
      });
    };
  }
}),

// DocsTable state, depends query state
(0, _withState2.default)('docs', 'setDocs', []), (0, _withHandlers2.default)({
  addQueryField: function addQueryField(_ref5) {
    var fields = _ref5.fields,
        setFields = _ref5.setFields;
    return function (key) {
      if (!fields.includes(key)) {
        setFields([].concat(_toConsumableArray(fields), [key]));
      }
    };
  }
}),

// control flow
(0, _withState2.default)('isLoading', 'setIsLoading', false), (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    processQueryDocs(this.props);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    processQueryDocs(this.props, prevProps);
  }
}),

// x-auth, x-schema, x-db, x-page
_controlToolButton2.default, // => actions

// x-uiSetting
(0, _withProps2.default)(function (_ref6) {
  var uiSetting = _ref6.uiSetting,
      schema = _ref6.schema;
  return {
    ui: _extends({
      title: schema.name
    }, getUi({ uiSetting: uiSetting, schema: schema }))
  };
}), // => ui

(0, _withProps2.default)(function (_ref7) {
  var gotoCreateDoc = _ref7.page.gotoCreateDoc;
  return { gotoCreateDoc: gotoCreateDoc };
}), (0, _bindHotKeys2.default)({
  gotoCreateDoc: 'ctrl+alt+n'
}), (0, _bindHotKeys2.default)({
  gotoCreateDoc: 'ctrl+b'
}), (0, _exposeProps2.default)(['isLoading', 'fields', 'setFields', 'query', 'setQuery', 'docs', 'addQueryField', 'ui', 'downloadQuery']))(_DocList2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/index.js
// module id = 1268
// module chunks = 0